<template lang="html">
  <ul v-if="isInvestmentFundsReady" class="drawer__selectors--list">
    <!--<li v-for="(instrument, index) in filteredInvestmentFunds" :key="instrument.id"-->
    <li v-if="isEmptyArray(data)" class="drawer__selectors--list--item drawer__selectors--list--item--empty">
      Nem található alap ezekkel a szűrőfeltételekkel. Módosítson a feltételeken.
    </li>
    <li v-for="({id, deviza, sorozat, isin, nev, teljes_nev, isMissingDataFromDatabase},index) in data" :key="id"
      class="drawer__selectors--list--item"
      :class="{'selected': (selectedFunds.length > 0 && selectedFunds.indexOf(parseInt(id)) > -1), 'empty': isMissingDataFromDatabase}"
      :data-currency="deviza"
      :data-series="sorozat"
      :data-isin="isin"
      :data-color="colors[index]"
      :data-fullName="teljes_nev"
      @click="selectFund(id, colors[index])"
    >
      <span
        class="drawer__selectors--list--item__marker"
        :class="colors[index]"
      ></span>
      <span class="drawer__selectors--list--item__text">
        <span class="drawer__selectors--list--item__text__name">
          {{nev}}
        </span>
        <span class="drawer__selectors--list--item__text__currency">{{deviza}}</span>
        <span class="drawer__selectors--list--item__text__series">{{sorozat}} sorozat</span>
      </span>
      <span v-if="isMissingDataFromDatabase" class="empty-disclaimer">
        Jelenleg még nincs elérhető adat.
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: null
    },
    selectedFunds: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    isInvestmentFundsReady () {
      return Boolean(this.data)
    },
  },

  methods: {
    selectFund(id, color) {
      this.$emit('select', {id, color})
    },

    isEmptyArray (array) {
      //If it's not an array, return FALSE.
      if (!Array.isArray(array)) {
          return true;
      }
      //If it is an array, check its length property
      if (array.length == 0) {
          //Return TRUE if the array is empty
          return true;
      }
      //Otherwise, return FALSE.
      return false;
    },
  }

}
</script>

<style lang="scss" scoped>
.condition-wrapper {
  width: 100%;
}

.drawer__selectors {
  &--list {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding: 0;
    width: 100%;

    &--item {
      flex: 1 0 calc(33.3333% - 10px);
      max-width: calc(33.3333% - 10px);
      width: 33.3333%;
      padding: 5px 10px;
      margin: 5px;
      border-radius: 2px;
      box-shadow: 0px 2px 12px rgba(0,0,0,0.1);
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: .75em;
      line-height: 130%;
      transition: all .2s ease-in-out;
      cursor: pointer;

      &:before {
        content: none!important;
      }     
      
      @media only screen and (max-width: 768px) {
        flex: 1 0 calc(50% - 10px);
        max-width: calc(50% - 10px);
        width: 50%;
      }

      @media only screen and (max-width: 500px) {
        flex: 1 0 100%;
        max-width: 100%;
        width: 100%;
        margin: 5px 0;
      }

      &.selected {
        background: #f4f4f4;
        box-shadow: inset 1px 1px 3px rgba(0,0,0,0.1);
      }

      &.empty {
        pointer-events: none;
        cursor: not-allowed;
        filter: grayscale(100%);
        box-shadow: none;
        background: rgba(0,0,0,0.05);
      }      

      &__marker {
        display: inline-flex;
        width: 5px;
        height: 8px;
        border-radius: 5px;
        flex: 1 0 15px;
        max-width: 15px;
        margin: 0 5px;
      }

      &__text {
        display: flex;
        flex: 1 1 auto;
        &__name {
          margin-right: auto;
        }

        &__currency {
          display: inline-flex;
          padding: 2px 4px;
          color: #fff;
          border-radius: 2px;
          background: #867e66;
          margin: 0 2px;
          margin-right: 5px;
        }

        &__series {
          border-radius: 50px!important;
          min-width: 19px;
          height: 19px;
          text-align: center;
          justify-content: center;
          align-items: center;
          background: #FDC828!important;
          color: #454545!important;
          padding: 0 5px;
        }
      }
    }
  }
}
.drawer__selectors--list.column {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  .drawer__selectors--list--item {
    flex: 1 1 100%;
    max-width: 100%;
    font-size: 1em;
    font-size: .9em;
  }
}


.empty-disclaimer {
  flex: 1 1 100%;
}
</style>
